import Detail from '@utils/detail'
import ExamineTimeSelector from './components/small/ExamineTimeSelector.vue'
import NoEvaluationSysTable from './components/NoEvaluationSysTable.vue'
import EvaluationSystem from './components/hasEvaluationSystem/EvaluationSystem.vue'
import ScoreResult from './components/hasEvaluationSystem/ScoreResult.vue'
import UseRule from './components/hasEvaluationSystem/UseRule.vue'
import http from '@plugin/axios'

const NO_ASSESS_SYSTEM = '0000'

// 获取详情
async function getData(data: any) {
  const row = data.row
  const res: any = await http({
    url: '/examineProcess/getExamineProcess',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { id: row.id }
  })
  const vmData: any = {
    purchaseUnitName: res.purchaseUnitName,
    assessSystemName: res.assessSystemName,
    assessSystemNo: res.assessSystemNo,
    workingPeriod: res.workingPeriod,
    workingPeriodName: res.workingPeriodName,
    examineMonth: res.examineMonth,
    examineMonthName: res.examineMonthName
  }
  if (Reflect.get(row, 'assessSystemNo') === NO_ASSESS_SYSTEM) {
    Reflect.set(vmData, 'detailList', {
      groupModel: res.groupModel,
      groupData: res.groupData
    })
  } else {
    const assessSystemData = res.assessSystemData
    vmData.workingDateName = res.workingDateName ?? '-'
    vmData.evaluationSystem = res.assessSystemData.tabList ?? []
    vmData.scoreResult = {
      scoreResult: assessSystemData.scoreResult ?? [],
      examineType: assessSystemData.examineType ?? ''
    }
    vmData.useRule = {
      judgeType: assessSystemData.judgeType ?? '',
      judgeTypeName: assessSystemData.judgeTypeName ?? '',
      materialCategory: assessSystemData.materialCategory ?? [],
      examList: assessSystemData.examList ?? []
    }
  }
  return vmData
}

const showEvaluationSystem = (vm: any): any => {
  return vm?.data && Reflect.get(vm.data, 'assessSystemNo') !== NO_ASSESS_SYSTEM
}

const showNoEvaluationSystem = (vm: any): any => {
  return vm?.data && Reflect.get(vm.data, 'assessSystemNo') === NO_ASSESS_SYSTEM
}

export default new Detail('performanceAppraisal.performanceAppraisal')
  .title('baseInfo')
  .getData(getData)
  .add('purchaseUnitName').label('purchaseUnit')
  .add('assessSystemName')
  .add('workingPeriodName').show(showNoEvaluationSystem)
  .add('examineMonthName').rowComponent(ExamineTimeSelector).bind('disabled', true).show(showNoEvaluationSystem)
  .add('workingPeriodName').show(showEvaluationSystem)
  .add('workingDateName').show(showEvaluationSystem)
  .addGroup().border(false)
  .add('detailList').rowComponent(NoEvaluationSysTable).bind('disabled', true).show(showNoEvaluationSystem)
  .addGroup().border(false)
  .add('evaluationSystem').rowComponent(EvaluationSystem).bind('disabled', true).show(showEvaluationSystem)
  .addGroup().border(false)
  .add('scoreResult').rowComponent(ScoreResult).bind('disabled', true).show(showEvaluationSystem)
  .addGroup().border(false)
  .add('useRule').rowComponent(UseRule).bind('disabled', true).show(showEvaluationSystem)
